import React, { useState, useRef, useEffect } from "react";
import { ax_claim_createIssue } from "../../api/warrantyForm";
import toast from "react-hot-toast";
import { ArrRefreshO } from "lovedicons/dist/arrO";
import imageCompression from "browser-image-compression";

const IssueForm = ({
  payloadData,
  tableData,
  setTableData,
  onPayloadDataChange,
  warrantyFormID,
  fetchAllClaimCreatedIssue,
  setSearchInput,
  setClaimData,
  isSubmitted,
  setIsSubmitted,
  formData,
  setFormData,
  images,
  setImages,
  selected,
  setSelected,
  showDealerField,
  setShowDealerField,
}) => {
  // Form States
  // const [formData, setFormData] = useState({
  //   claimNo: "",
  //   natureOfIssue: "",
  //   otherIssue: "",
  //   purchaseDate: "",
  //   location: "",
  //   dealerName: "",
  //   // uploadImg: null,
  //   // images: [],
  //   isTCChecked: false,
  //   createdFromBrand: "trackAndTrail",
  // });
  const [isLoading, setIsLoading] = useState(false); // eslint-disable-next-line
  const [isUploading, setIsUploading] = useState(false);

  // const [submittedData, setSubmittedData] = useState([]); // Stores the submitted form data
  // const [selected, setSelected] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  // const [showDealerField, setShowDealerField] = useState(false);

  // const [fileName, setFileName] = useState("");
  // const [isSubmitted, setIsSubmitted] = useState(
  //   tableData?.length > 0 &&
  //     tableData[tableData.length - 1]?.warrStatus === "Pending"
  //     ? true
  //     : false
  // ); // To make the form read-only after submission

  // const isResolved = tableData?.some((data) => data.warrStatus.toLowerCase() === "approved");
  const warrStatus =
    tableData?.length > 0 ? tableData[tableData.length - 1]?.warrStatus : "";

  // Disable submit button if form is submitted or warrStatus is "Pending"
  // const isSubmitDisabled = isSubmitted || warrStatus === "Pending";
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(
    isSubmitted || warrStatus === "Pending"
  );

  useEffect(() => {
    setIsSubmitDisabled(isSubmitted || warrStatus === "Pending");
  }, [isSubmitted, warrStatus]);

  const fileInputRef = useRef(null);
  const dropdownRef = useRef(null); // Ref for the dropdown container
  const options = ["Frame", "Rim", "Others"];

  // const [inputDisabled, setInputDisabled] = useState({
  //   isDisabled: tableData[0].warrStatus === "Pending" ? true : false,
  // });

  // const handleImageChange = (e) => {
  //   const imgArr = Array.from(e.target.files); // Convert FileList to Array

  //   if (imgArr.length + images.length > 3) {
  //     toast.error("You can upload a maximum of 3 images.");
  //     return;
  //   }

  //   setImages((prevImages) =>
  //     Array.isArray(prevImages) ? [...prevImages, ...imgArr] : [...imgArr]
  //   );
  // };

  const handleImageChange = async (e) => {
    const imgArr = Array.from(e.target.files); // Convert FileList to Array

    if (!imgArr.length) {
      console.log("No file selected");
      return;
    }

    if (imgArr.length + images.length > 3) {
      toast.error("You can upload a maximum of 3 images.");
      return;
    }

    setIsUploading(true);
    const processedImages = [];

    for (const file of imgArr) {
      console.log(
        `Original File: ${file.name}, Size: ${(file.size / 1024).toFixed(2)} KB`
      );

      if (file.size > 3 * 1024 * 1024) {
        // File > 2MB → Show Error & Clear Input
        toast.error(`"${file.name}" exceeds the 3MB file size limit.`);
        e.target.value = ""; // Clear input
        setIsUploading(false);
        return;
      }

      if (file.size <= 300 * 1024) {
        try {
          const webpFile = await imageCompression(file, {
            fileType: "image/webp",
          });
          console.log(
            `Converted WebP File: ${webpFile.name}, Size: ${(
              webpFile.size / 1024
            ).toFixed(2)} KB`
          );
          processedImages.push(webpFile);
        } catch (error) {
          console.error("WebP Conversion Error:", error);
          toast.error('conversion failed. Try again.');
          setIsUploading(false);
          continue; // Skip this file if conversion fails
        }
      } else {
        try {
          const options = {
            maxSizeMB: 0.5, 
            initialQuality: 0.8, 
            // maxWidthOrHeight: 1024, 
            useWebWorker: true, 
            fileType: "image/webp", 
          };

          let compressedFile = await imageCompression(file, options);
          toast.success('File compression and upload successfully')
          console.log(
            `Compressed WebP File: ${compressedFile.name}, Size: ${(
              compressedFile.size / 1024
            ).toFixed(2)} KB`
          );
        

          // Final Check: If still too large, show error and skip
          if (compressedFile.size > 500 * 1024) {
            toast.error('compression failed. Try again.');
            setIsUploading(false);
            continue;
          }

          processedImages.push(compressedFile);
        } catch (error) {
          console.error("Compression Error:", error);
          toast.error('compression failed. Try again.');
          setIsUploading(false);
          continue; // Skip this file if compression fails
        }
      }
    }

    setImages((prevImages) =>
      Array.isArray(prevImages)
        ? [...prevImages, ...processedImages]
        : [...processedImages]
    );
    setIsUploading(false);
  };

  const inputDisabled =
    tableData?.length > 0 &&
    tableData[tableData.length - 1]?.warrStatus === "Pending"
      ? false
      : true;

  // Handle dropdown selection
  const handleSelect = (option) => {
    setSelected(option);
    setFormData((prev) => ({ ...prev, natureOfIssue: option }));
    setIsOpen(false);
    setShowDealerField(option === "Others");
  };
  //base64 conversion
  // function fileToBase64(file) {
  //   return new Promise((resolve, reject) => {
  //     if (!(file instanceof File)) {
  //       // Ensure file is a File object
  //       reject(new Error("Invalid file type. Expected a File object."));
  //       return;
  //     }

  //     const reader = new FileReader();
  //     reader.readAsDataURL(file);
  //     reader.onload = () => resolve(reader.result.split(",")[1]); // Extract Base64 part
  //     reader.onerror = (error) => reject(error);
  //   });
  // }

  // Handle input change
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // Handle file upload
  // const handleFileChange = (event) => {
  //   const file = event.target.files[0];
  //   if (file) {
  //     setFileName(file.name);
  //     setFormData((prev) => ({ ...prev, images: file.name }));
  //   }
  // };

  // const handleFileChange = (event) => {
  //   const files = Array.from(event.target.files);
  //   if (files.length + formData.images.length > 3) {
  //     toast.error("You can upload a maximum of 3 images.");
  //     return;
  //   }
  // const handleFileChange = async (event) => {
  //   const files = Array.from(event.target.files); // Convert FileList to Array

  //   if (files.length + formData.images.length > 3) {
  //     toast.error("You can upload a maximum of 3 images.");
  //     return;
  //   }

  //   try {
  //     // Convert files to Base64
  //     const base64Files = await Promise.all(
  //       files.map(async (file) => {
  //         const base64 = await fileToBase64(file);
  //         return base64;
  //       })
  //     );

  //     // Prepare new images with their Base64 data
  //     const newImages = base64Files.map((base64String, index) => ({
  //       name: files[index].name,
  //       base64: base64String,
  //     }));

  //     setFormData((prev) => ({
  //       ...prev,
  //       images: [...prev.images, ...newImages],
  //     }));

  //     // console.log("Images in Base64:", newImages); // Log the new images
  //   } catch (error) {
  //     console.error("Error converting file to Base64:", error.message);
  //   }
  // };

  const handleRemoveImage = (index) => {
    // setFormData((prev) => ({
    //   ...prev,
    //   images: prev.images.filter((_, i) => i !== index), // Remove the selected image
    // }));

    setImages((prev) => prev.filter((_, i) => i !== index));

    if (fileInputRef.current) {
      fileInputRef.current.value = ""; // Clear the input file
    }
  };
  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (images.length === 0) {
      toast.error(
        "Please upload at least one image before submitting the form."
      );
      return;
    }
    if (!formData.natureOfIssue) {
      toast.error("Please select any option.");
      return;
    }
    if (!formData.location) {
      toast.error("Please fill the location field.");
      return;
    }
    if (!formData.isTCChecked) {
      toast.error("Please agree to the Terms and Conditions.");
      return;
    }

    setIsLoading(true);

    try {
      if (inputDisabled) {
        // Create FormData to send images
        const formDataToSend = new FormData();
        formDataToSend.append("frameNo", payloadData?.frameNo);
        formDataToSend.append("wowNo", payloadData?.wowNo);
        formDataToSend.append("natureOfIssue", formData.natureOfIssue);
        formDataToSend.append("otherIssue", formData.otherIssue);
        formDataToSend.append(
          "purchaseDate",
          inputDisabled ? payloadData?.purchaseDate : formData?.purchaseDate
        );
        formDataToSend.append("location", formData.location);
        formDataToSend.append(
          "dealerName",
          inputDisabled
            ? payloadData?.dealerName || "Online"
            : formData.dealerName
        );
        formDataToSend.append("createdFromBrand", formData.createdFromBrand);

        // Append images
        images.forEach((image) => {
          formDataToSend.append("images", image);
        });

        for (let pair of formDataToSend.entries()) {
          console.log(pair[0] + ": " + pair[1]);
        }
        console.log("?.images - ", formDataToSend?.images);

        // const {
        //   natureOfIssue,
        //   otherIssue,
        //   purchaseDate,
        //   location,
        //   dealerName,
        //   uploadImg,
        //   images,
        //   createdFromBrand,
        // } = formData;

        // const payload = {
        //   frameNo: payloadData?.frameNo,
        //   wowNo: payloadData?.wowNo,
        //   natureOfIssue,
        //   otherIssue,
        //   purchaseDate: inputDisabled
        //     ? payloadData?.purchaseDate
        //     : purchaseDate,
        //   location,
        //   // dealerName: inputDisabled ? payloadData?.dealerName : dealerName,
        //   dealerName: inputDisabled
        //     ? payloadData?.dealerName || "Online"
        //     : dealerName,
        //   uploadImg,
        //   images,
        //   createdFromBrand,
        // };
        // const warrantyFOrmID =

        const ax_createIssue = await ax_claim_createIssue(
          formDataToSend,
          warrantyFormID
        );

        // console.log("payload - " + JSON.stringify(payload));
        // console.log("ax_createIssue - " + JSON.stringify(ax_createIssue));
        console.log("ax_createIssue - " + JSON.stringify(ax_createIssue));
        if (ax_createIssue?.success === true) {
          setIsLoading(false);
          toast.success(ax_createIssue.description);
          await fetchAllClaimCreatedIssue(warrantyFormID);
          setIsSubmitted(true);
          setIsSubmitDisabled(false);
          setSearchInput("");
          setClaimData({
            name: "",
            frameNo: "",
            phone: "",
          });
        } else {
          // toast.error(ax_createIssue.description);
          setIsLoading(false);
          toast.error("An error occurred while submitting the form.");
        }
      }

      // setSubmittedData((prev) => [...prev, formData]); // Add new data to the table
      // Make form read-only after submission
      // alert("Form submitted successfully!");
    } catch (e) {
      setIsLoading(false);
      console.error("Error while creating a new issue: " + e);
    }
  };

  // Close dropdown if click happens outside of it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  console.log("images - ", images);
  // useEffect(() => {
  //   fetchAllClaimCreatedIssue();
  //   // setTableData(ax_createIssue.data);
  // }, [warrantyFormID]);
  // console.log(
  //   "tableData[tableData.length]?.warrStatus - " +
  //     tableData[tableData?.length]?.warrStatus
  // );

  return (
    <section className="text-black flex flex-col items-center mt-8">
      {/* {JSON.stringify(inputDisabled)} */}
      {/* {JSON.stringify(tableData?.length !== 0)}
      {JSON.stringify(tableData?.[tableData?.length - 1]?.warrStatus)}
      {JSON.stringify(
        tableData?.length !== 0 &&
          ["Pending", "Approved"].includes(
            tableData?.[tableData?.length - 1]?.warrStatus
          )
      )} */}

      {/* {`tableData?.length !== 0 - ${JSON.stringify(tableData?.length !== 0)}`}
      {`["Pending", "Approved"].includes(
          !tableData?.[tableData?.length - 1]?.warrStatus
        ) - ${JSON.stringify(
          ["Pending", "Approved"].includes(
            !tableData?.[tableData?.length - 1]?.warrStatus
          )
        )}`}
      {`isSubmitted - ${JSON.stringify(isSubmitted)}`} */}

      {/* {`tableData?.length !== 0 - ${JSON.stringify(tableData?.length !== 0)}`} */}
      {(tableData?.length !== 0 &&
        ["Pending", "Approved"].includes(
          !tableData?.[tableData?.length - 1]?.warrStatus
        )) ||
      isSubmitted ? null : (
        <div className="max-w-6xl w-full">
          {/* {JSON.stringify(warrantyFormID)} */}
          <form
            onSubmit={handleSubmit}
            className="flex flex-col gap-4 text-black"
          >
            <section className="xl:w-full flex lg:flex-row flex-col gap-6 xl:gap-8">
              <div className="mt-0.5 w-full flex flex-col gap-4">
                <div className="relative" ref={dropdownRef}>
                  <label
                    htmlFor="natureOfIssue"
                    className="block text-sm font-medium mb-1"
                  >
                    Natural Of Issue
                  </label>
                  <div
                    // className="flex justify-between items-center px-4 py-2 h-12 bg-[#f1f1f1] cursor-pointer "
                    // onClick={() => !isSubmitted && setIsOpen(!isOpen)}
                    className={`flex justify-between items-center px-4 py-2 h-12 bg-[#f1f1f1] cursor-pointer ${
                      isSubmitDisabled ? "opacity-50 cursor-not-allowed" : ""
                    }`}
                    onClick={() => {
                      if (!isSubmitDisabled) {
                        setIsOpen(!isOpen);
                      }
                    }}
                    id="natureOfIssue"
                    name="natureOfIssue"
                  >
                    <span className="text-sm text-gray-600">
                      {selected || "--Select--"}
                    </span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className={`h-5 w-5 transform transition-transform ${
                        isOpen ? "rotate-180" : "rotate-0"
                      }`}
                      viewBox="0 0 20 20"
                      fill="text-gray-600"
                    >
                      <path
                        fillRule="evenodd"
                        d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 011.06 1.06l-4 4a.75.75 0 01-1.06 0l-4-4a.75.75 0 01.02-1.06z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                  {isOpen && !isSubmitDisabled && (
                    <div className="absolute w-full bg-white mt-1 shadow-lg z-10">
                      {options?.map((option, index) => (
                        <div
                          key={index}
                          className={`px-4 py-2 text-md cursor-pointer ${
                            selected === option
                              ? "bg-gray-200 text-black border-l-4 border-[#7FC241]"
                              : "hover:bg-gray-200 text-black"
                          }`}
                          onClick={() => handleSelect(option)}
                        >
                          {option}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                {showDealerField && (
                  <div>
                    <label
                      htmlFor="otherIssue"
                      className="block text-sm font-medium"
                    >
                      Other Issue
                    </label>
                    <input
                      type="text"
                      id="otherIssue"
                      name="otherIssue"
                      placeholder="Ex: Handlebar broken"
                      value={formData.otherIssue}
                      onChange={handleChange}
                      className="mt-1 w-full p-3 bg-[#f1f1f1] outline-none focus:ring-2  focus:ring-orange-400 text-black"
                    />
                  </div>
                )}
              </div>

              <div className="w-full flex flex-col gap-4">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label
                      htmlFor="purchaseDate"
                      className="block text-sm font-medium"
                    >
                      Purchased Date
                    </label>
                    <input
                      type={!inputDisabled ? "text" : "date"}
                      // type="text"
                      id="purchaseDate"
                      name="purchaseDate"
                      value={
                        !inputDisabled
                          ? new Date(payloadData?.purchaseDate)
                              .toISOString()
                              .split("T")[0] // Display payload data when read-only
                          : new Date(payloadData?.purchaseDate)
                              .toISOString()
                              .split("T")[0] // Convert to YYYY-MM-DD
                        // : ""
                      }
                      onChange={
                        !inputDisabled
                          ? handleChange
                          : (e) => onPayloadDataChange("purchaseDate", e)
                      }
                      readOnly
                      disabled={!inputDisabled}
                      className="mt-1 w-full p-3 bg-[#f1f1f1] text-black outline-none  focus:ring-2 focus:ring-orange-400"
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="location"
                      className="block text-sm font-medium"
                    >
                      Location
                    </label>
                    <input
                      type="text"
                      id="location"
                      name="location"
                      placeholder="Location"
                      value={formData?.location}
                      onChange={handleChange}
                      disabled={!inputDisabled}
                      className="mt-1 w-full p-3 bg-[#f1f1f1] text-black outline-none  focus:ring-2 focus:ring-orange-400"
                    />
                  </div>
                </div>
                <div>
                  <label
                    htmlFor="dealerName"
                    className="block text-sm font-medium"
                  >
                    Purchased Service Dealer
                  </label>
                  <input
                    type="text"
                    id="dealerName"
                    name="dealerName"
                    placeholder="Purchased Service Dealer"
                    // value={
                    //   payloadData?.dealerName?.trim()
                    //     ? payloadData.dealerName
                    //     : payloadData?.sourceOfPurchase || ""
                    // }
                    value={
                      payloadData?.dealerName?.trim()
                        ? payloadData.dealerName
                        : "Online"
                    }
                    onChange={
                      !inputDisabled
                        ? handleChange
                        : (e) => onPayloadDataChange("dealerName", e)
                    }
                    readOnly
                    disabled={!inputDisabled}
                    className="mt-1 w-full p-3 bg-[#f1f1f1] text-black outline-none  focus:ring-2 focus:ring-orange-400"
                  />
                </div>
              </div>
            </section>
            <div>
              <label
                htmlFor="images"
                className="mt-2 flex max h-[68px] justify-center items-center font-semibold cursor-pointer border-dashed border-2 border-[#fffff]-600 "
              >
                {/* {fileName || formData?.images
                ? `Uploaded image: ${fileName || formData?.images}`
                : "Upload Image Here"} */}
                {isUploading ? (
                  <ArrRefreshO className="w-full h-6 animate-spin" />
                ) : (
                  "Upload Image Here"
                )}
              </label>
              <input
                ref={fileInputRef}
                id="images"
                name="images"
                type="file"
                accept=".png, .jpg, .jpeg"
                className="hidden"
                onChange={handleImageChange}
                disabled={!inputDisabled}
                multiple
              />
               <p className="text-xs text-gray-500 mt-1">
                Allowed formats: PNG, JPG, JPEG (Max: 3MB per file)
              </p>
            </div>
            {images.length > 0 && (
              <div className="mt-2 flex">
                {images.map((img, index) => (
                  <div key={index} className="flex items-center mt-1">
                    <img
                      src={URL.createObjectURL(img)} // Use createObjectURL for File objects
                      alt={img.name || "Uploaded Image"}
                      className="h-14 w-14 object-cover rounded-md mr-1 border-2 border-gray-100"
                    />

                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="32"
                      height="32"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      onClick={() => handleRemoveImage(index)}
                      className="text-gray-600 p-2 cursor-pointer"
                    >
                      <path d="M6 18L18 6M6 6l12 12"></path>
                    </svg>
                  </div>
                ))}
              </div>
            )}

            <div className="flex items-center gap-2">
              <input
                type="checkbox"
                id="isTCChecked"
                name="isTCChecked"
                checked={formData.isTCChecked}
                onChange={handleChange}
                disabled={!inputDisabled}
                className="h-4 w-4 text-yellow-400 border-gray-300 rounded focus:ring-yellow-400"
              />
              <label htmlFor="isTCChecked" className="text-sm font-medium">
                I agree to the{" "}
                <a
                  href="https://trackandtrail.in/pages/terms-and-conditions"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500 underline"
                >
                  Terms and Conditions
                </a>
              </label>
            </div>

            <div className="text-center">
              <button
                type="submit"
                className={`mt-6 px-6 py-3 font-semibold ${
                  !inputDisabled && "opacity-70 cursor-not-allowed"
                }`}
                disabled={isSubmitDisabled} // Button is disabled if either isSubmitted or warrStatus is "Pending"
                style={{
                  width: "200px",
                  backgroundColor: isSubmitDisabled ? "#6c757d" : "#30363E",
                  color: isSubmitDisabled ? "#fffdff" : "#fff",
                  // cursor: isSubmitDisabled ? "not-allowed" : "pointer",
                }}
              >
                {isLoading ? (
                  <ArrRefreshO className="w-full h-6 animate-spin" />
                ) : (
                  "Submit"
                )}
              </button>
            </div>
          </form>
        </div>
      )}

      {tableData?.length > 0 && (
        <div className="mt-10 w-full overflow-hidden overflow-x-auto">
          <h2 className="text-xl font-semibold mb-4">Submitted Data</h2>
          <table className="min-w-full">
            <thead className="bg-[#30363E] text-white">
              <tr>
                <th className="p-3 text-center texr-sm font-medium">S.No</th>
                <th className="p-3 text-center texr-sm font-medium">
                  Claim Number
                </th>
                <th className="p-3 text-center texr-sm font-medium">
                  Natural Of Issue
                </th>
                <th className="p-3 text-center texr-sm font-medium">
                  Other Issue
                </th>
                <th className="p-3 text-center texr-sm font-medium">
                  Purchased Date
                </th>
                <th className="p-3 text-center texr-sm font-medium">
                  Location
                </th>
                <th className="p-3 text-center texr-sm font-medium">
                  Purchased Dealer
                </th>
                {/* <th className="p-3 text-center texr-sm font-medium">Imgae</th> */}
                <th className="p-3 text-center texr-sm font-medium">Status</th>
              </tr>
            </thead>
            <tbody className="bg-gray-100">
              {tableData?.map((data, index) => {
                console.log("data - ", data);
                return (
                  <tr key={index}>
                    <td className="p-3 border border-gray-300">{index + 1}</td>
                    <td className="p-3 border border-gray-300">
                      {data.claimNumber}
                    </td>
                    <td className="p-3 border border-gray-300">
                      {data.natureOfIssue}
                    </td>
                    <td className="p-3 border border-gray-300">
                      {data.otherIssue || "N/A"}
                    </td>
                    <td className="p-3 border border-gray-300">
                      {new Date(data.purchaseDate).toISOString().split("T")[0]}
                    </td>
                    <td className="p-3 border border-gray-300">
                      {data.location}
                    </td>
                    <td className="p-3 border border-gray-300">
                      {data.dealerName}
                    </td>
                    {/* <td className="p-3 border border-gray-300">
                      {data.images && Array.isArray(data.images)
                        ? data.images.map((img, index) => (
                            <img
                              key={index}
                              src={img}
                              alt={`images`}
                              className="w-16 h-16"
                            />
                          ))
                        : "No Images"}
                    </td> */}
                    <td
                      className={`p-3 border border-gray-300 font-medium ${
                        data.warrStatus.toLowerCase() === "pending"
                          ? "text-orange-400"
                          : data.warrStatus.toLowerCase() === "rejected"
                          ? `text-red-500`
                          : "text-green-500"
                      }`}
                    >
                      {data.warrStatus}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
};

export default IssueForm;
